import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import '../../css/LoginForm.css';
import $ from 'jquery';

import { FormWithConstraints, FieldFeedback } from 'react-form-with-constraints';
import { FieldFeedbacks, FormGroup, FormControlLabel, FormControlInput } from 'react-form-with-constraints-bootstrap4';
import HmAjax from '../../util/HmAjax';
import UserStore from '../../util/UserStore';
import { isMobile, isTablet, isBrowser  } from 'react-device-detect';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';


class za_UserLoginType extends PreLoginPage {

	constructor(props) {
		super(props);

		this.state = {
				plp_userinput: '',
				submitButtonDisabled: false,
				loginType:"userid",
				loginMaxLength:254
		};

		this.handleChange = this.handleChange.bind(this);
		this.userIdChange = this.userIdChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.showCreateAccount = this.showCreateAccount.bind(this);
		
		this.myTrackerInstance = this.getTracker();
		
		this.navigationKey="PLP_Navigation";
		this.loginStoreKey="PLP_LOGIN_INFO";
	}

	componentDidMount(){
		this.sessionCheck();
	} 


	handleChange(e) {
		const target = e.currentTarget;	
		this.form.validateFields(target);

		this.setState({
			[target.name]: target.value,
			submitButtonDisabled: !this.form.isValid()
		});
	}

	userIdChange(e){
		const target = e.currentTarget;	
		// var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
		// if(phoneRegx.test(target.value)){
		// 	this.setState({loginType:"mobile",loginMaxLength:10});
		// }else{
		// 	this.setState({loginType:"email",loginMaxLength:254});
        // }
        this.setState({loginType:"email",loginMaxLength:254});
		this.handleChange(e);
		
		this.setState({			
			submitButtonDisabled: false
		});
		$(".userlogintypeformgroup .form-control-feedback").hide();
	}
	
	hmNav = function(userobj){
		//this.props.history.push('/landing');
		//console.log(this.props.myProps)
		//this.props.myProps.history.push(this.props.navigateURL);
		if(userobj && userobj.userRole.role == "PRNT"){
			if(this.props.navigateURL == "/landing"){
				window.top.location.href = "/myproducts";
			}else{
				window.top.location.href = this.props.navigateURL;
			}
		}else{
				window.top.location.href = this.props.navigateURL;
		}
		
	}

	submitForm = function(){
		if(this.state.plp_userinput.length<=0){
			return;
		}
		
		var formData = {
				"verificationId":this.state.plp_userinput
		}

		var me =this;
		var callBackSuccess = function(response){
			if(response !== null){
				console.log("response : ", response,"me.props.from:::",me.props.from);					
				if(response.user_exists){			
					//me.hmNav(response.user);
					me.props.showNewLoginForm(me.state.loginType,me.state.plp_userinput,me.props.from);
				}else{
					if(response.message == "provider_forbidden"){						
						me.setState({submitButtonDisabled: false, serverMessage: me.rb("google.errmsg.login")});
					}else{					
						me.props.showSignUp(me.state.loginType,me.state.plp_userinput,me.props.from);
					}					
				}
			}

			
		}

		var callBackFailure = function(response){
			console.log("response : ", response);
			me.trackMe(false);
		}

		new HmAjax(this.getUrlFor("GET_USER_STATUS")+this.state.loginType,formData).post(callBackSuccess,callBackFailure);
		new UserStore().clearOldUser();
	}
	
	handleSubmit(e) {
		e.preventDefault();
		$(".userlogintypeformgroup .form-control-feedback").show();
		this.form.validateFields();
		
		this.setState({ submitButtonDisabled: !this.form.isValid() });

		if (this.form.isValid()) {   
			this.submitForm();
		}
	}
	
	trackMe(result,userObj=null){		
		var trackObj = {
				"user_id" : (userObj == null) ? "" : userObj.userId,
				"login_id" : this.state.plp_userinput,
				"user_agent" : navigator.userAgent,
				"platform" : navigator.platform,
				"device" : isMobile ? "mobile" : (isTablet ? "tablet" : "PC"),
				"ip_address" : "ip_address",
				"result" : (result === true),
				"session_id" : (userObj == null) ? "" : userObj.authToken
		}

		this.initiateTrack("login",trackObj);
	}
	showCreateAccount(){
		this.props.callbackCreateAccount();
	}
	getUserInputPattern(){		
        return "^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$";
		// if(this.state.loginType == "mobile"){
		// 	return ".{10,}";
		// }else{
		// 	return "^[a-zA-Z0-9_+\\-%]+[a-zA-Z0-9_.+\\-%]+[a-zA-Z0-9_+\\-%]+@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}$";
		// }
	}
	render() {
		
		const styles=this.props.styles || {}

		if(this.state.loggedIn){
			return super.render();
		} else { 
			

			return (
				<div id="loginRoot" className="plpLogin">
				
				<div>
				
				
				<div className="nopadding userlogintypeContainer" style={styles}>
				

				<div className="text-center clearfix">
				
				<FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
				onSubmit={this.handleSubmit} noValidate>
					<div className="row col-12 userlogintyperoot">
						<div className="col-9 nopadding">
							<FormGroup for="plp_userinput" className="userlogintypeformgroup">
								{/* {( () => {
									if(this.state.loginType == "mobile"){
										return (
											<span className="countrycode">+91</span>
										);
									}
								})()} */}
								
								<FormControlInput type="plp_userinput" className={"plp_userinput userlogintype "+this.state.loginType} name="plp_userinput" placeholder={this.rb("login.userplaceholder.za")}
									value={this.state.plp_userinput} onChange={this.userIdChange}
								pattern={this.getUserInputPattern()}	
								required minLength={1} maxLength={this.state.loginMaxLength} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="1"/>
								
										
                                       {( () => {
											if(this.state.loginType == "mobile"){
												return (
													<FieldFeedbacks for="plp_userinput">
														<FieldFeedback when="valueMissing"><i className="material-icons errinfoicon">info</i> {this.rb("za_login.useridrequired")}</FieldFeedback>
														<FieldFeedback when="patternMismatch"><i className="material-icons errinfoicon">info</i> {this.rb("register.mobilenolength")}</FieldFeedback>
														 <FieldFeedback when={value => (value.length>0 && !/^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g.test(value))}><i className="material-icons errinfoicon">info</i> {this.rb("register.numbersonly")}</FieldFeedback>							 
														<FieldFeedback when="*" />
													</FieldFeedbacks>
												);
											}else{
												return (
													<FieldFeedbacks for="plp_userinput">
														<FieldFeedback when="valueMissing"><i className="material-icons errinfoicon">info</i> {this.rb("za_login.useridrequired")}</FieldFeedback>
														<FieldFeedback when="patternMismatch"><i className="material-icons errinfoicon">info</i> {this.rb("fpwd.validemail")}</FieldFeedback>														
													</FieldFeedbacks>	
												);
											}
										})()}
							</FormGroup>
							<div className="server-messages">{this.state.serverMessage}</div>
						</div>
						
						<div className="col-3 text-left joincontainer">
							<button data-ga={"Home - "+this.props.from+" Home- Join"} disabled={this.state.submitButtonDisabled} className="joinButton">{this.rb("join")}</button>
						</div>
					</div>
				</FormWithConstraints>	
				</div>
				</div>
				</div>


			
				</div>
		);}
	}
}

export default za_UserLoginType;



// WEBPACK FOOTER //
// ./src/views/za/za_UserLoginType.js